import { motion } from "framer-motion";
import { Search } from "lucide-react";

const BookingLoader = () => {
  const houseVariants = {
    animate: {
      scale: [1, 1.1, 1],
      rotate: [0, 5, -5, 0],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
  };

  const textVariants = {
    animate: {
      opacity: [0.5, 1, 0.5],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
  };

  return (
    <div className="flex flex-col items-center justify-center py-4">
      <motion.div className="relative text-blue-600" variants={houseVariants} animate="animate">
        <Search size={24} strokeWidth={1.5} />
      </motion.div>
      <motion.p
        className="mt-2 text-sm font-medium text-neutral-600 dark:text-neutral-300"
        variants={textVariants}
        animate="animate"
      >
        Recherche de disponibilités...
      </motion.p>
    </div>
  );
};

export default BookingLoader;
